import { useFieldArray, useFormContext } from 'react-hook-form'

import { Input } from '@/components/common/form/input'
import { InputImage } from '@/components/common/form/input-image'
import { Textarea } from '@/components/common/form/textarea'
import { InputMasks } from '@/utils/input-masks'

export type CallFormValues = {
  requesterName: string
  requesterPhone: string
  requesterMail: string
  description: string
  files: { file: File }[]
}

function RequesterName() {
  const { control } = useFormContext<CallFormValues>()
  return (
    <Input
      field_control={control}
      field_name="requesterName"
      field_label="Nome solicitante"
    />
  )
}

function RequesterPhone() {
  const { control } = useFormContext<CallFormValues>()
  return (
    <Input
      field_control={control}
      field_name="requesterPhone"
      field_label="Telefone"
      field_mask={InputMasks.ToTelefone}
    />
  )
}

function RequesterMail() {
  const { control } = useFormContext<CallFormValues>()
  return (
    <Input
      field_control={control}
      field_name="requesterMail"
      field_label="E-mail"
    />
  )
}

function Description() {
  const { control } = useFormContext<CallFormValues>()
  return (
    <Textarea
      field_control={control}
      field_name="description"
      field_label="Defeito reclamado"
    />
  )
}

function Evidences() {
  const { control } = useFormContext<CallFormValues>()
  const { fields, append, replace, remove } = useFieldArray({
    control,
    name: 'files',
  })

  return (
    <InputImage
      field_control={control}
      field_name="files"
      field_label="Evidências"
      field_files={fields.map((field) => field.file)}
      field_append={(files) => append(files.map((file) => ({ file })))}
      field_replace={(files) => replace(files.map((file) => ({ file })))}
      field_remove={remove}
      field_maxFileSizeMb={5}
      field_maxFiles={20}
    />
  )
}

export const CallFormFields = {
  RequesterName,
  RequesterPhone,
  RequesterMail,
  Description,
  Evidences,
}
